export const enum MotionDirection
{
    Up,
    Down,
    Left,
    Right
}

export interface MotionProps
{
    delay?: number;
    direction: MotionDirection;
    duration?: number;
}

interface MotionAttributes
{
    "data-motion-enabled": boolean;
    "data-motion-delay"?: string;
    "data-motion-direction": string;
    "data-motion-duration"?: string;
}

export const motionAttrs = (motionProps?: MotionProps): MotionAttributes | undefined => 
{
    if (motionProps === undefined)
    {
        return undefined;
    }

    const { delay, direction, duration = 1.5 } = motionProps;

    return {
        "data-motion-enabled": true,
        "data-motion-delay": delay?.toString(),
        "data-motion-direction": direction.toString(),
        "data-motion-duration": duration.toString()
    }
};
